import { render, staticRenderFns } from "./SavedQuerySelect.vue?vue&type=template&id=fdf951e4"
import script from "./SavedQuerySelect.vue?vue&type=script&lang=js"
export * from "./SavedQuerySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports